import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Table, PageHeader, Tag, Select, Space } from "antd";
import { DollarOutlined } from "@ant-design/icons";
import { handleApiError, MyBreadcrumb } from "utils";
import { billingPaymentListService } from "services/billing";
import { PAYMENT_METHODS, money } from "../constants";

const { Option } = Select;

export default function PaymentIndex() {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [methodFilter, setMethodFilter] = useState("");

  const columns = [
    { title: "Date", dataIndex: "payment_date", key: "payment_date" },
    {
      title: "Invoice",
      key: "invoice",
      render: (t, r) =>
        r.invoice ? (
          <a onClick={() => history.push("/billing/invoices/view/" + r.invoice._id)}>
            {r.invoice.invoice_number}
          </a>
        ) : (
          "-"
        ),
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      align: "right",
      render: (t) => money(t),
    },
    {
      title: "Method",
      dataIndex: "payment_method",
      key: "payment_method",
      render: (t) => (
        <Tag>{(PAYMENT_METHODS.find((p) => p.value === t) || {}).label || t}</Tag>
      ),
    },
    { title: "Transaction ID", dataIndex: "payment_id", key: "payment_id" },
    { title: "Note", dataIndex: "internal_note", key: "internal_note" },
  ];

  useEffect(() => {
    loadData();
  }, [methodFilter]);

  const loadData = () => {
    setIsLoading(true);
    billingPaymentListService(methodFilter ? { payment_method: methodFilter } : {})
      .then((response) => {
        setIsLoading(false);
        setDataSource(response.data.items || []);
      })
      .catch((error) => {
        setIsLoading(false);
        handleApiError(error);
      });
  };

  return (
    <div>
      <MyBreadcrumb
        items={[
          { label: "Home", path: "/" },
          { label: "Billing", path: "" },
          { label: "Payments", path: "" },
        ]}
      />
      <PageHeader
        ghost={false}
        avatar={{ icon: <DollarOutlined /> }}
        title="Payments"
        subTitle="All recorded transactions"
      />
      <Space style={{ margin: "16px 0" }}>
        <Select
          allowClear
          placeholder="Filter by method"
          style={{ width: 200 }}
          value={methodFilter || undefined}
          onChange={(v) => setMethodFilter(v || "")}
        >
          {PAYMENT_METHODS.map((p) => (
            <Option key={p.value} value={p.value}>
              {p.label}
            </Option>
          ))}
        </Select>
      </Space>
      <Table dataSource={dataSource} columns={columns} loading={isLoading} rowKey="_id" />
    </div>
  );
}
